<template>
  <vx-card no-shadow>

    <!-- Info -->
      <vs-input class="w-full mb-base" label-placeholder="Username" :value="model.username" disabled></vs-input>
      <vs-input class="w-full mb-base" label-placeholder="Name" v-model="model.name"></vs-input>
      <vs-input class="w-full mb-base" label-placeholder="NIP" :value="model.nip" disabled></vs-input>
      <vs-input class="w-full mb-base" label-placeholder="Email" v-model="model.email"></vs-input>
      <vs-input class="w-full mb-base" label-placeholder="Phone" v-model="model.hp"></vs-input>
      <vs-textarea class="w-full mb-base" label="Note" v-model="model.note"></vs-textarea>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="saveChange()">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>
import user from "@/api/user.js";

export default {
  data() {
    return {
        model: {
            username: '',
            name: '',
            email: '',
            hp: '',
            note: '',
            nip:'',
        }
    }
  },
    mounted() {
      this.getMyProfile();
    },
    methods: {
        async getMyProfile() {
            const me = await user.me();
            const userDetail = me.data.data[0] ? me.data.data[0] : {};
            this.model = {
                username : userDetail.username,
                email : userDetail.email,
                name : userDetail.name,
                hp : userDetail.phone,
                note : userDetail.note,
                nip: userDetail.nip
            }
        },
        saveChange() {
            user.updateMe(this.model, {
                headers: {
                    "content-type": "application/json"
                }
            }).then(response => {
                if (response.data.status) {
                    this.$vs.notify({
                        title: "Info",
                        time: 3000,
                        text:
                            "Data telah berhasil di submit",
                        color: "success",
                        position: "top-right"
                    });
                } else {
                    this.$vs.notify({
                        title:
                            "Terjadi Kesalahan",
                        time: 3000,
                        text: response.data.message,
                        color: "danger",
                        position: "top-right"
                    });
                }
            });
        }
    }
}
</script>
